module.exports = __webpack_public_path__ + "img/resumegreenicon.0e4308c5.svg";